import { keys, replace } from 'ramda';
import { Component } from 'react';
import * as Hosts from './component-hosts';
import s from './Playground.module.scss';

const NO_COMPONENT = '---';
const ComponentsAndEditors = {
    [NO_COMPONENT]: () => <div>- select a component -</div>,
    ...Hosts,
};

const hostNames = keys(ComponentsAndEditors).sort();

const resolveComponentId = value => (ComponentsAndEditors[value] ? value : NO_COMPONENT);

const hostOption = comp => (
    <option key={comp} value={comp}>
        {replace('Host', '', comp)}
    </option>
);

class Playground extends Component {
    constructor(props) {
        super(props);
        this.state = { currentComponent: localStorage.getItem('playground-component') };
    }

    onComponentSelected = e => {
        localStorage.setItem('playground-component', e.target.value);
        this.setState({ currentComponent: resolveComponentId(e.target.value) });
    };

    onClick = () => {
        global.location = '/venues';
    };

    renderSelectOptions = () => hostNames.map(hostOption);

    render() {
        const Editor = ComponentsAndEditors[this.state.currentComponent];

        return (
            <div className={s.playground}>
                <div className={s.topWrapper}>
                    <button type="button" onClick={this.onClick}>
                        Go to app{' '}
                    </button>
                    <div className={s.selectArea}>
                        Or select a component to preview:&nbsp;
                        <select onChange={this.onComponentSelected} value={this.state.currentComponent}>
                            {this.renderSelectOptions()}
                        </select>
                    </div>
                </div>
                <div className={s.editorWrapper}>{Editor && <Editor />}</div>
            </div>
        );
    }
}

export default Playground;
